import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  constructor() { }
  private loaderSubject = new BehaviorSubject(false);

  loader = this.loaderSubject.asObservable();

  get loading() {
    return this.loaderSubject.value;
  }

  set loading(loading) {
    this.loaderSubject.next(loading);
  }

  start() {
    this.loading = true;
  }

  stop() {
    this.loading = false;
  }
}
